var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSharedPrivateExtensions = function SvgSharedPrivateExtensions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.772 10.09c0-3.26 0-4.889.635-6.133a5.818 5.818 0 0 1 2.542-2.543C5.194.78 6.823.78 10.082.78h3.821c3.259 0 4.888 0 6.133.634a5.818 5.818 0 0 1 2.542 2.543c.634 1.244.634 2.874.634 6.132v3.822c0 3.258 0 4.888-.634 6.132a5.818 5.818 0 0 1-2.542 2.543c-1.245.634-2.874.634-6.133.634h-3.821c-3.259 0-4.888 0-6.133-.634a5.819 5.819 0 0 1-2.542-2.543C.772 18.8.772 17.17.772 13.911v-3.822Z",
    fill: "url(#shared-private-extensions_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.772 10.09c0-3.26 0-4.889.635-6.133a5.818 5.818 0 0 1 2.542-2.543C5.194.78 6.823.78 10.082.78h3.821c3.259 0 4.888 0 6.133.634a5.818 5.818 0 0 1 2.542 2.543c.634 1.244.634 2.874.634 6.132v3.822c0 3.258 0 4.888-.634 6.132a5.818 5.818 0 0 1-2.542 2.543c-1.245.634-2.874.634-6.133.634h-3.821c-3.259 0-4.888 0-6.133-.634a5.819 5.819 0 0 1-2.542-2.543C.772 18.8.772 17.17.772 13.911v-3.822Z",
    fill: "url(#shared-private-extensions_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.742 12h3.61m-6.704 0h.516m-1.61 3.094h8.891a2 2 0 0 0 2-2v-2.188a2 2 0 0 0-2-2h-8.89a2 2 0 0 0-2 2v2.188a2 2 0 0 0 2 2ZM15.996 5.555H8.004a.387.387 0 1 0 0 .773h7.992a.387.387 0 1 0 0-.773ZM15.996 18.445H8.004a.387.387 0 1 1 0-.773h7.992a.387.387 0 1 1 0 .773Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shared-private-extensions_svg__a",
    x1: 0.772,
    y1: 0.78,
    x2: 23.212,
    y2: 23.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shared-private-extensions_svg__b",
    x1: 0.772,
    y1: 0.78,
    x2: 23.212,
    y2: 23.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5764F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A339A"
  })))));
};

export default SvgSharedPrivateExtensions;